import { Button, Modal, Result } from "antd";
import { ReactComponent as SuccessIcon } from '../../../../../assets/images/success.svg';
import { ReactComponent as ErrorIcon } from '../../../../../assets/images/error.svg';

interface ModalProps {
    visible: boolean;
    onOk: () => void;
    onCancel: () => void;
    status: "success" | "error",
    okText?: string,
    cancelText?: string,
    title: React.ReactNode,
    noCancelButton?: boolean,
    isLoading?: boolean,
    onDeny: () => void;
}

const iconMap = {
    success: <SuccessIcon />,
    error: <ErrorIcon />
}

const AuctionAcceptConfirmModal = ({ visible, onOk, onCancel, status, okText, cancelText, title, noCancelButton, isLoading, onDeny }: ModalProps) => {
    return (
        <Modal
            visible={visible}
            onOk={onOk}
            onCancel={onCancel}
            footer={false}
            className="custom-modal disable-modal-close"
        >
            <Result
                icon={iconMap[status]}
                title={<span className="font-size-16">{title}</span>}
                extra={[
                    ...noCancelButton ? [] : [<Button
                        className="button-gray"
                        key="cancel"
                        style={{ width: 160, height: 50 }}
                        onClick={onDeny}>
                        {cancelText || "HUỶ BỎ"}
                    </Button>],
                    <Button
                        loading={isLoading}
                        className="button-light-yellow"
                        key="ok"
                        style={{ width: 160, height: 50 }}
                        onClick={onOk}>
                        {okText || "ĐỒNG Ý"}
                    </Button>
                ]}
            />
        </Modal>
    )
}

export default AuctionAcceptConfirmModal;